import { jsx as _jsx } from "react/jsx-runtime";
import { FlexBox, Spinner } from '@dixa/lib-shared-habla';
export const AnalyticsFilterLayoutLoading = () => (_jsx(FlexBox, Object.assign({ as: "li", padding: "250 300", alignItems: "center", justifyContent: "center" }, { children: _jsx(Spinner, { size: 20 }) })));
